import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class CookieConsentService {
  private consentChanged: BehaviorSubject<boolean> = new BehaviorSubject(null);
  public emitter: Observable<boolean> = this.consentChanged.asObservable();

  getConsent(): boolean {
    let accept;
    try {
      accept = parseInt(localStorage.getItem('website_cookie_consent_accept'));
    /* tslint:disable:no-empty */
    } catch (e) { }
    /* tslint:enable */

    if (accept === 1)
      return true;
    if (accept === 0)
      return false;
    return null;
  }

  setConsent(consent: boolean): void {
    this.consentChanged.next(consent)
    try {
      localStorage.setItem('website_cookie_consent_accept', consent ? '1' : '0');
    /* tslint:disable:no-empty */
    } catch (e) { }
    /* tslint:enable */
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/utils/cookie/cookie-consent.service.ts